import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import styled, { css } from 'styled-components'
import CloseIcon from '../../atoms/icons/CloseIcon'
import { brandSoftGrey } from '../../../assets/consts/color'

export const Backdrop = styled.div`
  position: fixed;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 90;

  opacity: 0;
  pointer-events: none;
  background-color: white;
  overflow: auto;
  transition:
    all 0.25s ease-in-out,
    color 0.25s ease-in-out;

  ${({ open }) =>
    open &&
    css`
      opacity: 0.98;
      pointer-events: all;
    `}
`

const Container = styled.div`
  position: relative;
  height: 100%;
`

const CloseButton = styled.button`
  position: absolute;
  top: 80px;
  right: 0px;

  border: none;
  background-color: transparent;
  transition:
    color 0.25s ease-in-out,
    color 0.25s ease-in-out;

  &:hover {
    color: ${brandSoftGrey};
    cursor: pointer;
  }

  @media only screen and (min-width: 48em) {
    top: 104px;
    right: 24px;
  }
`

function FullPageModal({
  open,
  onClose,
  modalRef,
  preventCloseClick,
  children,
  selector = '#modal-root',
}) {
  const [mounted, setMounted] = useState(false)
  const [container, setContainer] = useState(null)

  const handleBackdropClick = (e) => {
    if (
      (e.target.parentElement.dataset.backdrop || e.target.dataset.backdrop) &&
      !preventCloseClick
    )
      onClose()
  }

  const handleCloseButtonClick = () => {
    if (!preventCloseClick) onClose()
  }

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : 'unset'

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [open])

  useEffect(() => {
    const el = document.querySelector(selector)
    if (el) {
      setContainer(el)
      setMounted(true)
    }
  }, [selector])

  if (!mounted || !container) return null

  return createPortal(
    <Backdrop ref={modalRef} open={open} onClick={handleBackdropClick} data-backdrop>
      <Container className="modal_top-banner">
        {children}
        {!preventCloseClick && (
          <CloseButton onClick={handleCloseButtonClick}>
            <CloseIcon />
          </CloseButton>
        )}
      </Container>
    </Backdrop>,
    container
  )
}

export default FullPageModal
